import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-helpbutton',
  templateUrl: './helpbutton.component.html',
  styleUrls: ['./helpbutton.component.scss']
})
export class HelpbuttonComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
